/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.51"
        height="94.33"
        viewBox="0 0 85.51 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M27.88 83.48v10.85h-2.5V83.48h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M18.93 83.48v10.85h-2.5V83.48h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M17.68 61.19a1.22 1.22 0 0 1 1.24 1.13v21.19a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-21.2a1.24 1.24 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M9.98 83.48v10.85h-2.5V83.48h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M8.73 40.89a1.26 1.26 0 0 1 1.25 1.12v41.5a1.24 1.24 0 0 1-1.27 1.22 1.26 1.26 0 0 1-1.22-1.09v-41.5a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M48.72 83.48v10.85h-2.5V83.48h2.5zM17.69 4.51a9.42 9.42 0 1 0 9.41 9.43 9.41 9.41 0 0 0-9.41-9.43Zm0 2.5a6.92 6.92 0 1 1-6.92 6.92 6.92 6.92 0 0 1 6.88-7Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M66.95 2.92H46.22v17.39h20.73Zm-2.48 2.5v12.39H48.72V5.42Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M65.72 6.38h19.79l-8.34 8.7 8.34 8.69H60.62v-4.72h2.5v2.22h16.53l-5.95-6.19 5.95-6.2H65.72v-2.5z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M48.04 26.2a5.001 5.001 0 1 1 .22 10H27.88v47.31a1.24 1.24 0 0 1-1.12 1.24h-.13a1.25 1.25 0 0 1-1.24-1.12V34.98a1.24 1.24 0 0 1 1.1-1.24h21.55a2.51 2.51 0 0 0 .17-5H10.95a8.4 8.4 0 0 0-8.41 8.12v23.13a1.3 1.3 0 0 0 1.14 1.26h5.1a1.25 1.25 0 0 1 1.32 1.18 1.27 1.27 0 0 1-1.19 1.32h-5.1a3.77 3.77 0 0 1-3.76-3.57V37.12a10.91 10.91 0 0 1 10.61-10.91h37.43Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M47.47 34.97v48.51"/>
        <path
          fill="#fff"
          d="M47.49 33.73a1.24 1.24 0 0 1 1.24 1.12v48.66a1.252 1.252 0 0 1-2.5.13V34.98a1.26 1.26 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M47.47 1.25v26.19"/><path
          fill="#fff"
          d="M47.49.01a1.24 1.24 0 0 1 1.24 1.12v26.32a1.252 1.252 0 0 1-2.5.13V1.26A1.26 1.26 0 0 1 47.48 0Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonHoldingGroundedFlagIcon';

export default Icon;
